import * as React from "react"
import { Button } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

export default function TourButton({ onClick }) {
    return (
        <Button
            variant="outlined"
            size="small"
            onClick={onClick}
            startIcon={<IconSeeker icon="route" iconType="fontAwesome" sx={{ fontSize: 13 }} />}
            sx={{
                textTransform: "none",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: "0.8rem",
                whiteSpace: "nowrap",
                flexShrink: 0,
            }}
        >
            Take a Tour
        </Button>
    )
}
